import { LitElement, html, css, styleMap, utils } from '@hh/global.js'
class HHStickyHeader extends LitElement {
  static properties = {
    closeWhenHidden: {
      type: String,
      attribute: 'close-when-hidden',
    },
    _state: {
      type: Number,
      state: true,
    },
    _height: {
      type: Number,
      state: true,
    },
  }

  constructor() {
    super()

    this.headerBounds = {}
    this.currentScrollTop = 0
    this.closeWhenHidden = 'hh-details-modal'

    this._state = -1
  }

  connectedCallback() {
    super.connectedCallback()
    this.onScrollHandler = this.onScroll.bind(this)
    window.addEventListener('scroll', this.onScrollHandler)
    this.createObserver()
    setTimeout(() => {
      this.setSpacerHeight()
    }, 0)

    window.addEventListener('resize', () => {
      this._calculateHeaderHeight()
    })
    window.addEventListener('modalOpened', () => {
      this._calculateHeaderHeight()
    })
  }

  disconnectedCallback() {
    super.disconnectedCallback()
    window.removeEventListener('scroll', this.onScrollHandler)
    window.removeEventListener('resize', () => {
      this._calculateHeaderHeight()
    })
    window.removeEventListener('modalOpened', () => {
      this._calculateHeaderHeight()
    })
  }

  createObserver() {
    let observer = new IntersectionObserver((entries, observer) => {
      this.headerBounds = entries[0].intersectionRect
      observer.disconnect()
    })

    observer.observe(this)
  }

  setSpacerHeight() {
    const { height } = this.getBoundingClientRect()
    this._height = height
    this._state = 0
    this._calculateHeaderHeight()
  }

  _calculateHeaderHeight() {
    this.announcementBar = document.querySelector('announcement-bar')
    const { height, top } = this.getBoundingClientRect()

    document.documentElement.style.setProperty(
      '--hh-header-height',
      top + height + 'px'
    )
  }

  onScroll() {
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop

    if (
      scrollTop > this.currentScrollTop &&
      scrollTop > this.headerBounds.bottom
    ) {
      requestAnimationFrame(this.hide.bind(this))
    } else if (
      scrollTop < this.currentScrollTop &&
      scrollTop > this.headerBounds.bottom
    ) {
      requestAnimationFrame(this.reveal.bind(this))
    } else if (scrollTop <= this.headerBounds.top) {
      requestAnimationFrame(this.reset.bind(this))
    }

    this.currentScrollTop = scrollTop
  }

  hide() {
    if (this._state === 1) {
      return
    }
    this._state = 1
    this.classList.add('scroll-down')
    this._calculateHeaderHeight()

    utils.all(this.closeWhenHidden, this.header).map((element) => {
      element.setAttribute('open', false)
    })
  }

  reveal() {
    if (this._state === 2) {
      return
    }
    this._state = 2
  }

  reset() {
    if (this._state === 0) {
      return
    }
    this.classList.remove('scroll-down')
    this._state = 0
    this._calculateHeaderHeight()
  }

  render() {
    return html`<div
      class="container"
      style="${styleMap({
        position: this._state === -1 ? 'relative' : 'sticky',
        transform: this._state === 1 ? `translateY(0)` : 'translateY(0)',
      })}"
    >
      <slot> </slot>
      <slot name="logo"></slot>
    </div>`
  }

  static styles = css`
    .container {
      left: 0;
      top: 0;
      width: 100%;
      z-index: var(--hh-z-index, 100);
      transform: translateY(0);
      transition: transform var(--hh-duration-long, 10ms);
      background-color: var(--hh-background, transparent);
    }

    .spacer {
      position: relative;
    }
  `
}

customElements.define('hh-sticky-header', HHStickyHeader)
